import { defineSlotRecipe } from '@chakra-ui/react'
import { tabsAnatomy } from '@chakra-ui/react/anatomy'

export const tabsSlotRecipe = defineSlotRecipe({
    slots: tabsAnatomy.keys(),
    variants: {
        variant: {
            dashboard: {
                root: {
                    height: '100%',
                },
                trigger: {
                    borderBottom: '4px solid',
                    borderBottomColor: 'transparent',
                    boxSizing: 'border-box',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    height: 'auto',
                    mb: '-1px',
                    padding: '16px 20px',
                    position: 'relative',
                    _selected: {
                        borderBottomColor: 'accent.500',
                    },
                    '& .chakra-badge': {
                        position: 'absolute',
                        top: 0,
                    },
                    _light: {
                        color: 'rgba(84, 79, 64, 0.7)',
                        _selected: {
                            color: 'dark.700',
                        },
                    },
                    _dark: {
                        color: 'rgba(255, 255, 255, 0.7)',
                        _selected: {
                            color: 'white',
                        },
                    },
                },
                list: {
                    borderBottom: '1px solid ',

                    display: 'inline-flex',
                    _light: { borderBottomColor: 'rgba(84, 79, 64, 0.12)' },
                    _dark: { borderBottomColor: 'rgba(255, 255, 255, 0.3)' },
                },
                content: {
                    height: '100%',
                    padding: '0',
                },
            },
        },
    },
})
